module.exports = __webpack_public_path__ + "static/media/RABONA.bbcebee4.png";